import { useContext, useEffect } from "react";
import { WebrtcContext } from "../modules/Webrtc";
import VideoContainerStream from "../Components/VideoContainer/VideoContainerStream";
import { useParams } from "react-router-dom";

function Ifram() {
  const { streamReadyToPlay } = useContext(WebrtcContext);

  let { idsw } = useParams();

  useEffect(() => {
    const init = () => {
      if (localStorage.getItem("___init__config___")) return;
      localStorage.setItem("___init__config___", "true");

      if (idsw) {
        const data = idsw && JSON.parse(atob(idsw));
        if (data && Object.keys(data).length) {
          console.log(" DATA IFRAM ARE : ", data);

          // setTimeout(() => {
          //   handlePlayStream(data.id, data.name);
          // }, 5000);
        }
      }
    };
    init();
  });
  return (
    <VideoContainerStream
      idsw={idsw}
      style={{
        width: "99vw",
        height: "99vh",
      }}
    />
  );
}

export default Ifram;
